import { CONTENT_URL } from "../api/Definitions"
import { eVideoVersions, iVideoVersions } from "../definitions/Video"

export function useVideoUrl(
  version: eVideoVersions = eVideoVersions.original,
  versions: iVideoVersions = {},
) {
  const pp = versions[eVideoVersions[version]]?.meta?.pipePath

  if (pp) {
    return `${CONTENT_URL}${pp}`
  }
  return ""
}
